import * as mutations from './mutations'
import * as actions from './actions'
import i18n from '@/i18n'
// TODO: billformats and pdfFileFormats have to be rewriten once backend updates.
export default {
  namespaced: true,
  state () {
    return {
      countries: [],
      residences: [],
      cities: [],
      queue: [],
      types: [],
      units: [],
      classes: [],
      taxes: [],
      notes: [],
      reasons: [],
      ivatypes: [],
      billformats: [],
      paymenttypes: [],
      downloadfileformats: [],
      expedients: [],
      pdfFileFormats: [],
      fileTypes: [],
      rectifiedReasons: [],
      events: [],
      statusOptions: [],
      paymentMethodType: [],
      documentNature: [],
      representationType: [],
      documentType: [],
      loaded: false,
      searchableDocuments: [
        {
          id: 1,
          name: "NIF"
        },
        {
          id: 2,
          name: "CIF"
        },
        {
          id: 3,
          name: "NIE"
        },
        {
          id: 4,
          name: i18n.t('invoices.filter.other')
        }
      ],
      referenceT: []
    }
  },
  mutations,
  actions
}
